export const standardVisas = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'TN1', 'TN2', 'H1-B', 'O1A', 'O1B'];
export const standardSubtasks = ['I130','I130ONLINEEFILE','PERM', 'RECEFF', 'PWD'];
export const standardImmClassification = ['EB2ADVDEG'];